import { cva } from '@/styled-system/css';

export const photoCarouselDotRecipe = cva({
  base: {
    alignItems: 'center',
    backgroundColor: 'icon.transparent.onImpact.neutral-fixed',
    borderRadius: 'shape.ellipse',
    boxShadow: 'none',
    display: 'inline-flex',
    flex: 'none',
    height: 'indicator.sm',
    justifyContent: 'center',
    marginInline: 'tightest',
    transitionProperty: {
      _motionReduce: 'none',
      _motionSafe: 'background-color, height, margin, width',
    },
    transitionDuration: {
      _motionReduce: '0s',
      _motionSafe: '{durations.250}',
    },
    transitionTimingFunction: '{easings.ease}',
    width: 'indicator.sm',
  },
  variants: {
    isContinuation: {
      false: {},
      true: {
        height: 'indicator.xs',
        width: 'indicator.xs',
      },
    },
    isHidden: {
      false: {},
      true: {
        height: '0',
        marginInline: '0',
        width: '0',
      },
    },
    selected: {
      false: {},
      true: {
        backgroundColor: 'icon.onImpact.neutral-fixed',
        height: 'indicator.md',
        width: 'indicator.md',
      },
    },
  },
});
